<mat-checkbox
  #checkbox
  (change)="checkboxGroup.toggleValue(value); change.emit($event)"
  [checked]="checkboxGroup.isSelected(value)"
  color="primary"
  >{{ label }}</mat-checkbox
>
